import React from 'react';
import './Chapters.scss';
import PullQuote from '../PullQuote/PullQuote';

function Chapter8() {
  return (
    <>
      <section className="chapter">
        <p className="chapter__paragraph">
          “For the most part, people desire to be green,” Wilkinson adds. “How can we create an
          opt-in experience for the residents and employees of Miller’s Landing to compare their
          green efforts against their peers? This has the additional benefit of creating community.”
        </p>
        <p className="chapter__paragraph">
          According to Ilhan, the biggest challenge for the developers in creating Miller’s Landing
          is future-enabling the networking implementation. For Intel, future-enabling Miller’s
          Landing means anticipating advances in tech and preparing for inevitable updates to
          current implementations. Ilhan knows his team must guide the development and imagine ways
          for the network to scale. But thanks to innovations from Intel and its ecosystem, the
          future of SmartTowns looks promising. The capacity for interconnected neighborhoods and
          cities is increasing, which will improve life for citizens.
        </p>
      </section>
      <section>
        <PullQuote
          quote={
            'We’re building the Miller’s Landing network for the next 100 years, not the next 10.'
          }
          author={'Ken Wilkinson,'}
          source={'Layer 10'}
        />
      </section>
      <section className="chapter">
        <p className="chapter__paragraph">
          “It’s impossible to predict the future of smart building and smart-city technology,”
          Wilkinson says, “But what I am comfortable predicting is that it will not include fewer
          devices, fewer services, requiring less bandwidth. This is why we focus on architecting a
          robust network infrastructure. We’re building the Miller’s Landing network for the next
          100 years, not the next 10.”
        </p>
      </section>
    </>
  );
}

export default Chapter8;
